export const getVideoDimensions = (format) => {
  switch (format) {
    case "story":
      return { width: 1080, height: 1920 };
    case "feed":
      return { width: 1080, height: 1350 };
    case "tv_horizontal":
      return { width: 1920, height: 1080 };
    case "tv_vertical":
      return { width: 1080, height: 1920 };
    default:
      return { width: 1080, height: 1920 }; // padrão story
  }
};